module.exports = __webpack_public_path__ + "img/ratio.18e0ca3c.png";